export default "__VITE_ASSET__CdneIH29__"